import { format } from "date-fns";
import { ProyectoPorUsuario } from "./BusquedaPersonalDTO";
import { ProyectoBusqueda } from "./ProyectoBusqueda";
import { TablaProductoIngresadoDTO } from "./TablaProductoIngresadoDTO";
import { ProyectoEvntDTO } from "./ProyectosDTOS/EventoProyDTO";
import { EvntHistorialProyectoDTO } from "./ProyectosDTOS/EvntHistorialProyectoDTO";
import { SolicitudItinerarioDTO } from "./Itinerario/SolicitudItinerarioDTO";
import { SolicitudAyudanteInvestigacion } from "../componentes/ayudantias/SolicitudAyudantesInvestigacion";
import { SolicitudAyudanteInv } from "./ayudantias/SolicitudAyudanteInv";
import { AyudanteInvInfo } from "./ayudantias/AyudanteInvInfo";
import { PeriodoAcademicoDTO } from "./SAAC/PeriodoAcademicoDTO";
import { AyudTesisPeriodoDTO } from "./ayudantias/AyudTesisPeriodo";
import { ProyectoParticipoDTO } from "./ProyectosDTOS/ProyectoParticipoDTO";

export interface DataBsqProy {
    rowsPerPage: Array<number>,
    data: Array<ProyectoBusqueda>,
    editable?: boolean,
    esAdmin?:boolean,
    token?:any
}

export interface DataBsqPersonal {
    rowsPerPage: Array<number>,
    data: Array<ProyectoPorUsuario>,
    archivo: string,
    iduser: number,
    token: string
}

export interface DataEventosProy {
    rowsPerPage: Array<number>,
    data: Array<ProyectoEvntDTO>,
    esAdmin?:boolean,
    token?:any
}

export interface DataHistorialUser {
    rowsPerPage: Array<number>,
    data: Array<EvntHistorialProyectoDTO>,
    esAdmin?:boolean,
    token?:any
}

export interface DataProductoIngresado {
    rowsPerPage: Array<number>,
    data: Array<TablaProductoIngresadoDTO>,
    proyParticipo?: Array<ProyectoParticipoDTO>,
    mostrarAlert: boolean,
    ready?: boolean,
    titulo?: string,
    mensajeAlert?:string,
}

export interface DataSolicitudItinerarioProy {
    rowsPerPage: Array<number>,
    data: Array<SolicitudItinerarioDTO>,
    periodoActivo: PeriodoAcademicoDTO,
    fechasItinerario: AyudTesisPeriodoDTO,
    token:any
}

export interface DataSolicitudAyudantiasProy {
    rowsPerPage: Array<number>,
    data: Array<AyudanteInvInfo>,
    periodoActivo: PeriodoAcademicoDTO,
    fechasAyudantias: AyudTesisPeriodoDTO,
    token:any
}

export function parseFechaCadena(cadena: string=""): string {
    const parsedDate = new Date(cadena);
    // Verificar si la fecha es válida
    if (isNaN(parsedDate.getTime())) {
      console.error("Formato de fecha inválido");
      return '';
    }
    const tt = format(parsedDate,'dd/MM/yyyy');  
    return tt;
}

